import type { ColumnDef } from "@tanstack/react-table";

import type { HelperOptions } from "@/components/DataTable/types";
import Icon from "@/components/Icon/Icon";
import TooltipAlert from "@/components/Tooltip/TooltipAlert";

import type { TableRow } from "../../../types";

export default function CheckValidColumn(
  id: "isValid",
  helperOptions: HelperOptions = {},
): ColumnDef<TableRow> {
  const { minWidth } = helperOptions;

  return {
    accessorKey: id,
    enablePinning: false,
    enableHiding: false,
    meta: { thStyle: { minWidth } },
    header: () => null,
    cell: ({ row }) => {
      const error = (() => {
        if (row.original.isValid) {
          return <Icon iconName="Check" size={12} colorVariant="success" />;
        }
        if (
          row.original.errorCellsCount === 0 &&
          row.original.recordErrors &&
          row.original.recordErrors.length > 0
        ) {
          // セルに紐づくエラーが0件なのにエラーがある場合は行全体でエラーが発生している
          return (
            <TooltipAlert
              content={row.original.recordErrors?.join("\n") ?? ""}
              value={row.original.errorCellsCountI18n}
            />
          );
        }
        return (
          <span className="whitespace-nowrap text-sm text-error-on-neutral-fill">
            {`${row.original.errorCellsCount} ${row.original.errorCellsCountI18n}`}
          </span>
        );
      })();

      return <div className="flex items-center justify-center">{error}</div>;
    },
  } satisfies ColumnDef<TableRow>;
}
